<template>
  <router-link v-bind:to="stationLink(station.id)" class="afdc-station-link">
    <div v-bind:class="$route.path.includes('/station/') && $store.getters.stationDetails.id === station.id ? 'afdc-station afdc-station-selected' : 'afdc-station'" @mouseenter="increasePinSize" @mouseleave="decreasePinSize">
      <div class="afcd-row afdc-no-gutters afdc-station-row">
        <div :class="mode === 'route' ? 'afdc-col-10' : 'afdc-col-9'">
          <div class="afdc-station-name">
            {{ station.station_name }}
          </div>
          <small>
            {{ station.street_address }}<br>
            {{ stationCityStateZip(station.city, station.state, station.zip) }}
          </small>
          <small v-if="station.fuel_type_code ==='ELEC'">
            {{ stationEvLevels(station.ev_level1_evse_num, station.ev_level2_evse_num, station.ev_dc_fast_num) }}
          </small>
          <template v-if="mode === 'route'">
            <div class="afdc-small afdc-route-distance">{{ distanceLabel }}</div>
          </template>
        </div>
        <div class="afdc-small afdc-distance" :class="mode === 'route' ? 'afdc-col-2' : 'afdc-col-3'">
          <div class="afdc-fuel-marker-container">
            <div v-bind:class="stationPinColor(station.fuel_type_code)" aria-hidden="true">{{ stationPinLetter(index) }}</div>
            <img v-bind:src="require(`@/assets/images/${$store.getters.isNavActiveFindModeRoute ? 'markers' : 'pins'}/${station.fuel_type_code}.svg`)" v-bind:alt="$store.getters.loaderFuelNamesByKey[station.fuel_type_code]" v-bind:class="$store.getters.isNavActiveFindModeRoute ? 'afdc-fuel-marker' : 'afdc-fuel-pin'">
          </div>
          <template v-if="mode !== 'route'">{{ distanceLabel }}</template>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    station: {
      required: true,
    },
    mode: {
      required: true,
    },
    index: {},
  },

  computed: {

    // Determine the distance units to use for the results being displayed.
    //
    // For routing: Use whatever units were selected in distance input menu.
    //
    // For nearby stations: We don't have an explicit units menu, so base this
    // on the country. When the tool is only searching specific countries, then
    // use the native units for those countries. When the tool is searching
    // across multiple countries, then try to detect which units should be used
    // based on the search location (so if searching in Canada, use km,
    // otherwise miles).
    distanceUnit() {
      let distanceUnit;
      if (this.$store.getters.isNavActiveFindModeRoute) {
        distanceUnit = this.$store.getters.getFilterValueWithDefault('distance_unit');
      } else {
        switch (this.$store.getters.localeCountry) {
          case 'CA':
            distanceUnit = 'km';
            break;
          case 'US':
            distanceUnit = 'mi';
            break;
          default:
            if (this.$store.getters.nearestStationsSearchLocationCountry === 'CA') {
              distanceUnit = 'km';
            } else {
              distanceUnit = 'mi';
            }
            break;
        }
      }

      return distanceUnit;
    },
    distanceLabel() {
      const distanceFormat = { minimumFractionDigits: 1, maximumFractionDigits: 1 };
      let distance;
      let message;
      if (this.distanceUnit === 'km') {
        distance = this.$formatNumber(this.station.distance_km, distanceFormat);
        if (this.mode === 'route') {
          message = this.$t('%s km from route');
        } else {
          message = this.$t('%s km');
        }
      } else {
        distance = this.$formatNumber(this.station.distance, distanceFormat);
        if (this.mode === 'route') {
          message = this.$t('%s mi from route');
        } else {
          message = this.$t('%s mi');
        }
      }

      return this.$sprintf(message, distance);
    },
  },

  methods: {
    stationLink(stationId) {
      // close the station show page when a user clicks on the station again in the results list
      if (this.$route.name === 'StationShow' && this.$route.params.id.toString() === stationId.toString()) {
        return {
          name: this.$store.getters.getNavActiveFilterRouteName,
          query: this.$store.getters.getFilters,
        };
      }
      return {
        name: 'StationShow',
        params: { id: stationId },
      };
    },

    increasePinSize() {
      this.$store.commit('setResultsHover', this.station.id);
    },

    decreasePinSize() {
      this.$store.commit('setResultsHover', false);
    },
  },
};
</script>

<style lang="scss">
</style>
